const DeviceType = Object.freeze({
  WEIGHT_SCALE: 'Weight Scale',
  SPHYGMOMANOMETER: 'Sphygmomanometer',
})

export default DeviceType